import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Sparkles } from "lucide-react";
import { PLAN_LABEL } from "@/lib/plans";

export const UpgradeLock = ({ required = "pro", feature = "This feature", description }) => {
  const navigate = useNavigate();
  const label = PLAN_LABEL[required] || required;
  return (
    <div className="flex items-center justify-center py-10" data-testid="upgrade-lock">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-2xl shadow-sm p-10 text-center">
        <div className="h-14 w-14 mx-auto rounded-2xl bg-emerald-900 flex items-center justify-center">
          <Lock className="h-6 w-6 text-white" />
        </div>
        <span className="inline-block mt-5 text-xs font-bold uppercase tracking-wider bg-accent/10 text-accent rounded-full px-3 py-1">{label} plan</span>
        <h3 className="font-heading text-2xl font-bold tracking-tight mt-3">{feature} is a {label} feature</h3>
        <p className="text-slate-500 text-sm mt-2">{description || `Upgrade to ${label} to unlock ${feature.toLowerCase()} and grow your pipeline.`}</p>
        <button onClick={() => navigate(`/dashboard/billing?plan=${required}`)} data-testid="upgrade-lock-button"
          className="mt-6 bg-emerald-900 text-white rounded-md px-6 py-3 text-sm font-medium hover:bg-emerald-800 transition-all hover:-translate-y-0.5 inline-flex items-center gap-2">
          <Sparkles className="h-4 w-4" /> Upgrade to {label}
        </button>
      </div>
    </div>
  );
};

export default UpgradeLock;
